var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userIsLoggedInState)?_c('image-to-text-base-page',{attrs:{"allow-library":true},on:{"select-from-library":_vm.openSelectFromLibraryModal}}):_c('image-to-text-landing-page')}
var staticRenderFns = []

export { render, staticRenderFns }